import { createFileRoute, useRouter } from "@tanstack/react-router";
import { CreateOrderDialog } from "@/features/my/orders/create";

export const Route = createFileRoute("/(member)/(protected)/my/orders/create")({
  component: CreateOrderRoute,
});

function CreateOrderRoute() {
  const router = useRouter();

  const handleClose = () => {
    router.history.back();
  };

  return <CreateOrderDialog open={true} onClose={handleClose} />;
}
